import { Flex } from "antd"
import React from "react"
import { Outlet } from "react-router-dom"

import { FixedContainer } from "../../../components/FixedContainer.tsx"
import { ProposalsHeader } from "./ProposalsHeader.tsx"
import ProposalsSidebar from "./ProposalsSidebar/ProposalsSidebar.tsx"

export function ProposalsLayout() {
  return (
    <FixedContainer>
      <ProposalsHeader />

      <Flex flex={1} gap={"middle"} className={"overflow-hidden"}>
        <ProposalsSidebar />
        <Outlet />
      </Flex>
    </FixedContainer>
  )
}
